<div class="container bg-light p-5 min-vh-100">
  <h1 class="text-danger">404</h1>
  <h3 class="text-danger">Page Not Found</h3>
  <p class="mt-4">Sorry, the page you are looking for might be in another section of the factory.</p>
  <p>Go back to <a routerLink="/">home</a>.</p>
</div>
